<template>
	<nav
		:aria-label="ariaLabel"
		:class="clsx(className, 'flex gap-x-2')">
		<slot />
	</nav>
</template>

<script lang="ts">
	export default { name: 'VPagination' } // name the component
</script>

<script setup lang="ts">
	import { 
		clsx
	} from 'clsx'

	const props = defineProps({
		ariaLabel: {
			type: String,
			default: 'Page navigation'
		},
		className: {
			type: String,
			default: ''
		}
	})
</script>